module.exports = __webpack_public_path__ + "img/yk.6043c384.png";